import type { FeatureFlagsConfig } from '@aibees/shared/feature-flags';
import { FeatureFlags } from '../types';

export const FEATURE_FLAGS: FeatureFlagsConfig = {
  [FeatureFlags.SAMPLE_FEATURE]: true,
  [FeatureFlags.FILTER_PEOPLE_SKILLS]: true,
  [FeatureFlags.CRAWL_REQUEST]: 'stg', // only use useIsCrawlRequestFeatureEnabled
  [FeatureFlags.FILTER_COMPANY_BULK_SEARCH]: 'prod',
  [FeatureFlags.FILTER_PEOPLE_BULK_SEARCH]: 'prod',
  [FeatureFlags.FILTER_COMPANY_PEOPLE_TECHNOLOGIES]: 'prod',
  [FeatureFlags.INTEGRATION_SMARTLEAD]: 'stg', // only use useIsSmartleadIntegrationEnabled
  [FeatureFlags.PEOPLE_LOOKALIKE_SEARCH]: 'stg', // only use useIsPeopleLookalikeEnabled
  [FeatureFlags.PEOPLE_EXPORT_TEMPLATE]: 'prod',
  [FeatureFlags.COMPANY_EXPORT_TEMPLATE]: 'prod',
  [FeatureFlags.BILLING_PAGE]: 'prod',
  [FeatureFlags.PEOPLE_ENRICHMENT]: 'prod',
  [FeatureFlags.EMAIL_ENRICHMENT]: 'dev',
  [FeatureFlags.RESEND_INVITE_EMAIL]: 'prod',
  [FeatureFlags.ALERTS]: false,
  [FeatureFlags.BUYING_TEAM]: false,
  [FeatureFlags.ENRICHMENT]: 'prod',
  [FeatureFlags.COMPANY_SEMANTIC_SEARCH]: false,
  [FeatureFlags.BACK_OFFICE]: false,
  [FeatureFlags.PEOPLE_PHONE_NUMBER]: 'prod',
  [FeatureFlags.SEARCH_TABLE_COLUMN_MODIFIER]: 'prod',
  [FeatureFlags.FILTER_PEOPLE_JOB_TITLE_AI_SEARCH]: 'stg',
  [FeatureFlags.TOP_LOOKALIKE_PEOPLE_ON_PEOPLE_PAGE]: 'stg',
  [FeatureFlags.EXPORT_COMPANY_FOLLOWER_COUNT]: false,
  [FeatureFlags.EXPORT_COMPANY_NAIC_CODE]: false,
  [FeatureFlags.EXPORT_COMPANY_SIC_CODE]: false,
  [FeatureFlags.EXPORT_PEOPLE_AI_SEARCH_INPUT]: false,
  [FeatureFlags.EXPORT_PEOPLE_RELEVANCY_SCORE]: false,
  [FeatureFlags.EXPORT_PEOPLE_WORK_DIRECT_PHONE]: false,
  [FeatureFlags.EXPORT_PEOPLE_HOME_PHONE]: false,
};
